import { ReactNode } from 'react';
import { useTheme } from 'styled-components';
import { Disclaimer, Div } from '../../styles';

export const Table = () => {
  return <div>Table</div>;
};

type TableColumn = {
  label: ReactNode;
  width: string;
  hidden?: boolean;
};

export const TableHeader = ({
  columns,
  padding = '0 24px',
  gap = '32px',
}: {
  columns: TableColumn[];
  padding?: string;
  gap?: string;
}) => {
  // Through ThemeProvider rather than lightTheme so a navy-primary app
  // (deliveries) does not get a vGrubs-red table header.
  const theme = useTheme();
  return (
    <Div
      $background={theme.primary}
      $mb="8"
      $flex
      $alignCenter
      $gap={gap}
      $gapSM="16px"
      $desktop
      $minHeight="32px"
      $p={padding}
      $borderRadius="16px"
    >
      {columns.map((column, i) =>
        column.hidden ? null : (
          <Div $width={column.width} key={i}>
            <Disclaimer $m="0" $color={theme.white}>
              {column.label}
            </Disclaimer>
          </Div>
        )
      )}
    </Div>
  );
};
